export default __webpack_public_path__ + "static/media/30993905530@sbi.8142c4cb.png";